<droplist class="trimester-droplist" [items]='service.items()' [selectedItem]='service.selectedTrimesterDropdownOption()' (selectionChange)='service.onViewDroplistChange($event)' sortBy='customSort'>
</droplist>